module.exports = __webpack_public_path__ + "assets/img/18_1687_big.8c4d4465.jpg";